 <div class="carouselAndButtonsWrapper"> 
        <div class="carousel-wrapper">
            <div class="chips">
                <mat-chip-listbox  class="chipsList" #chipList>
                     <mat-chip-option 
                        *ngFor="let chipItem of chips;let chipIdx = index"
                        [selected]="isChipSelected(chipIdx)"
                        [value]="chipIdx"
                        (click)="chipSelect(chipItem, chipIdx)">
                        {{chipItem}}
                    </mat-chip-option>
                </mat-chip-listbox>
            </div>
            <div class="carousel">
                <div *ngFor="let item of items;" class="carousel-item" [ngStyle]="transition()">
                    <ng-container [ngTemplateOutlet]="item.tpl">
                    </ng-container>
                </div>
            </div>
        </div>
        <button *ngIf="showOverControls" mat-flat-button (click)="movePrev()" [ngClass]="'carousel__button--prev'">
                <mat-icon [ngStyle]="{'color':commandControlsColor}" *ngIf="isRTL">keyboard_arrow_right</mat-icon>
                <mat-icon [ngStyle]="{'color':commandControlsColor}" *ngIf="!isRTL">keyboard_arrow_left</mat-icon>
        </button>
        <button *ngIf="showOverControls" mat-flat-button (click)="moveNext()" [ngClass]="'carousel__button--next'">
                <mat-icon [ngStyle]="{'color':commandControlsColor}" *ngIf="isRTL">keyboard_arrow_left</mat-icon>
                <mat-icon [ngStyle]="{'color':commandControlsColor}" *ngIf="!isRTL">keyboard_arrow_right</mat-icon>
        </button>
    </div> 
    <div class="footerControls">
            <button *ngIf="showFooterControls" mat-flat-button (click)="movePrev()" class="carousel__button--prev">
                <mat-icon [ngStyle]="{'color':commandControlsColor}" *ngIf="isRTL">keyboard_arrow_right</mat-icon>
                <mat-icon [ngStyle]="{'color':commandControlsColor}" *ngIf="!isRTL">keyboard_arrow_left</mat-icon>
                
            </button>
            <div class="dotsStepper" *ngIf="showDotsStepper">
                <span *ngFor="let item of items;let i = index" [ngClass]="stepperDot(i)" [ngStyle]="{'background-color':commandControlsColor}"></span>
            </div>
    
                <button *ngIf="showFooterControls" mat-flat-button (click)="moveNext()" class="carousel__button--next">
                <mat-icon [ngStyle]="{'color':commandControlsColor}" *ngIf="isRTL">keyboard_arrow_left</mat-icon>
                <mat-icon [ngStyle]="{'color':commandControlsColor}" *ngIf="!isRTL">keyboard_arrow_right</mat-icon>
        </button>
    </div>
  
 